// extracted by mini-css-extract-plugin
module.exports = {"content":"FormTabs_content__zAAcn","childContent":"FormTabs_childContent__X5red"};